<ambita-loading-indicator>
  <div class="ambita-loading-indicator"></div>
  <div>{ opts.loadingText }</div>
  <script>
    import './loadingIndicator.scss';
  </script>
</ambita-loading-indicator>
